import { Stack } from '@mui/material';
import React, { lazy, Suspense, useRef, useState } from 'react';
import UsersFilter from './UsersFilter';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import UsersMenu from './menu/UsersMenu';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import { useAppSelector } from '../../../store';
import { TEST_MODE } from '../../../enums/enums';
import {
  setSelectUser,
  setTotalUsers,
  setUsersPayload,
  setUsersResult
} from '../../../store/apps/usersSlice';
import { mockUsers } from '../../../enums/mock';
import { API_USERS } from '../../../api/users';
import { useDispatch } from 'react-redux';
import { useEventListener } from 'usehooks-ts';

const UsersPagination = lazy(() => import('./UsersPagination'));
const UserTable = lazy(() => import('./UserTable'));

export default function UserListContent({
  setDefaultSelectGroupId,
  openMobileMenu,
  setOpenMobileMenu
}) {
  const dispatch = useDispatch();
  const { isLessTablet } = useBootstrapSize();
  const usersContentRef = useRef();

  const listPayload = useAppSelector((state) => state.users.list.payload);
  const users = useAppSelector((state) => state.users.list.result);
  const pageSize = listPayload?.pageSize;
  const pageNo = listPayload?.pageNo;

  const [updateTicker, setUpdateTicker] = useState(false);

  const maxHeight = isLessTablet ? 'calc(100svh - 210px)' : '100%';

  const onFindClick = (param = {}, { successFn } = {}) => {
    // const allFilter = { ...filter, pageNo: curPage, pageSize: selectRecord };
    const allFilter = { ...listPayload, ...param };
    if (!allFilter.groupId) return;

    if (allFilter.hasDeposit !== 'yes') {
      delete allFilter.depositCurrency;
      delete allFilter.depositAmountTo;
      delete allFilter.depositAmountFrom;
      delete allFilter.depositCurrency;
      delete allFilter.depositDateFrom;
      delete allFilter.depositDateTo;
    }

    if (allFilter.depositCurrency == 'skip') {
      allFilter.depositCurrency = null;
    }

    if (TEST_MODE) {
      const data = mockUsers;
      const list = data.userList;
      dispatch(setUsersResult(list));
      dispatch(setUsersPayload(allFilter));
      dispatch(setTotalUsers(data.total.userCount));
      return;
    }

    API_USERS.list(allFilter)
      .then((e) => {
        const data = e.data.data || {};
        const page = data.page || {};
        const list = data.userList || [];
        dispatch(setUsersPayload({ ...allFilter, count: page.count, pageNo: page.no }));
        dispatch(setUsersResult(list));
        dispatch(setTotalUsers(data.total?.userCount || 0));
        setUpdateTicker(Math.random());
        dispatch(setSelectUser({}));
        setTimeout(() => successFn?.(), 60);
      })
      .catch(console.error);
  };

  useEventListener('UserListContent.onFindClick', (e) => {
    onFindClick({}, e.detail);
  });

  return (
    <Stack display={'flex'} direction={'row'} gap={2}>
      <Stack gap={3} flex={1} overflow={'auto'} maxHeight={maxHeight} ref={usersContentRef}>
        <Stack gap={1}>
          <UsersFilter
            setDefaultSelectGroupId={setDefaultSelectGroupId}
            setUpdateTicker={setUpdateTicker}
            onFindClick={onFindClick}
          />
        </Stack>
        <ShowContainer condition={users.length}>
          <Stack gap={1}>
            <Suspense>
              <UserTable
                users={users}
                updateTicker={updateTicker}
                beginValueIndex={(pageNo - 1) * pageSize}
              />
            </Suspense>
            <Suspense>
              <UsersPagination onFindClick={onFindClick} />
            </Suspense>
          </Stack>
        </ShowContainer>
      </Stack>
      <UsersMenu
        usersContentRef={usersContentRef}
        maxHeight={maxHeight}
        openMobileMenu={openMobileMenu}
        setOpenMobileMenu={setOpenMobileMenu}
      />
    </Stack>
  );
}
